import { TDBitToggle, TOGGLE_KEY_NAME } from "./constant";
export var versionRegExp = /\d+([._]\d+)*/;
export var namedVersionRegExp = function (name) { return new RegExp("\\b".concat(name, "\\W+\\d+([\\._]\\d+)*"), 'i'); };
/**
 * 从字符串中取出连续的数字和小数点/下划线作为版本号
 * - 始终取字符串中第一段有数字和小数点/下划线（可以没有小数点/下划线）的连续子串，忽略其他字符
 * - 将下划线转换成小数点
 * - 如果字符串中根本没有数字，返回 null
 * @param versionString 可能含有版本号的字符串
 */
export function normalizeVersion(versionString) {
    var _a;
    var match = versionRegExp.exec(versionString);
    return (_a = match === null || match === void 0 ? void 0 : match[0].replace(/_/g, '.')) !== null && _a !== void 0 ? _a : null;
}
/**
 * 版本号转换为整数列表
 * - 始终取字符串中第一段有数字和小数点/下划线（可以没有小数点/下划线）的连续子串，忽略其他字符
 * - 如果字符串中根本没有数字，返回空列表
 * - 由小数点/下划线隔开的每一段数字当作整数处理，例如 1.02 中的 02 当作 2 处理
 * - 末尾如果有 0 会被保留，例如 3.0.0 -> [3, 0, 0]
 * @param version 版本号
 */
export function versionToList(versionString) {
    var version = normalizeVersion(versionString);
    return (version === null || version === void 0 ? void 0 : version.split('.').map(Number)) || [];
}
/**
 * 比较两个整数列表
 * @param list1 第一个数字列表
 * @param list2 第二个数字列表
 * @returns -1(list1<list2) | 0(list1=list2) | 1(list1>list2)
 */
export function compareList(list1, list2) {
    var result = Array(Math.max(list1.length, list2.length))
        .fill(0)
        .map(function (_, i) { return (list1[i] || 0) - (list2[i] || 0); })
        .find(function (k) { return k !== 0; }) || 0;
    if (result < 0)
        return -1;
    if (result > 0)
        return 1;
    return 0;
}
/**
 * 比较两个版本号字符串
 * - 始终取字符串中第一段有数字和小数点/下划线（可以没有小数点/下划线）的连续子串，忽略其他字符
 * - 如果字符串中根本没有数字，当作 0 版本处理
 * - 由小数点/下划线隔开的每一段数字当作整数处理，例如 1.02 和 1.2 是一样的，请注意适用范围
 * - 末尾有 .0 会被忽略，例如 2 = 2.0 = 2.0.0
 * @param ver1 第一个版本号字符串
 * @param ver2 第二个版本号字符串
 * @returns -1(ver1<ver2) | 0(ver1=ver2) | 1(ver1>ver2)
 */
export function compareVersion(ver1, ver2) {
    return compareList(versionToList(ver1), versionToList(ver2));
}
/**
 * 从 userAgent 中取出以某前缀后面（可以隔一个符号，例如空格或者斜杠）出现的版本号
 * - 在前缀之前没有出现字母数字，才会匹配
 * - 前缀不区分大小写，例如 micromessenger 可以匹配 MicroMessenger/6.2
 * - 如果找不到或者后面根本没有数字，返回 null
 * @param prefix 要提取的平台前缀，例如 MicroMessenger
 * @param ua 原始 userAgent
 */
export function getVersionFromUA(prefix, ua) {
    var regExp;
    try {
        regExp = namedVersionRegExp(prefix);
    }
    catch (e) {
        return null;
    }
    var match = regExp.exec(ua);
    if (!match)
        return null;
    return normalizeVersion(match[0].substring(prefix.length));
}
/** 从环境中获取 User Agent. */
export var getUserAgent = /* #__PURE__ */ (function () {
    var userAgent;
    return function () {
        // 服务端渲染不会提供 window，会提供 global 供兼容 - sigma
        if (userAgent === undefined) {
            userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : '';
        }
        return userAgent;
    };
})();
// 下面一系列函数将第一个参数是 userAgent 的函数, 转换为支持自动获取的, 并将 userAgent 移到末尾.
// 这种固定参数的写法在运行时速度最快, 包体积最小, 但是有一些魔法和类型体操, 不懂勿改.
export function withDefaultUA(fn) {
    return function (userAgent) {
        return fn(userAgent || getUserAgent());
    };
}
export function withDefaultUAAndVersion(fn) {
    return function (version, userAgent) {
        return fn(userAgent || getUserAgent(), version);
    };
}
/**
 * 桌面端获取UA设置使用
 * @param option
 * @returns
 */
export function getBitToggleSetting(option) {
    var flags = 0; // 初始值为 0000;
    if (option.fullOffline) {
        flags |= TDBitToggle.fullOfflineModeAvailable;
    }
    if (option.nativeDatabase) {
        flags |= TDBitToggle.nativeDatabaseAvailable;
    }
    if (option.nativeDatabaseWillDeprecated) {
        flags |= TDBitToggle.nativeDatabaseWillDeprecated;
    }
    return "".concat(TOGGLE_KEY_NAME, "/").concat(flags);
}
